var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProdInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42857 17.5C5.52169 16.0102 5 14.2647 5 12.3986C5 6.93174 9.47715 2.5 15 2.5C20.5228 2.5 25 6.93174 25 12.3986C25 14.2647 24.4783 16.0102 23.5714 17.5",
    stroke: "#676767",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22859 21.3728C9.11375 21.027 9.05633 20.8541 9.06302 20.7141C9.07717 20.4179 9.26392 20.1578 9.53946 20.0507C9.66974 20 9.85131 20 10.2145 20H19.7855C20.1487 20 20.3303 20 20.4605 20.0507C20.7361 20.1578 20.9228 20.4179 20.937 20.7141C20.9437 20.8541 20.8862 21.027 20.7714 21.3728C20.5592 22.0118 20.4531 22.3313 20.2894 22.59C19.9465 23.1321 19.409 23.5209 18.7882 23.676C18.4919 23.75 18.1563 23.75 17.4852 23.75H12.5148C11.8437 23.75 11.5081 23.75 11.2118 23.676C10.591 23.5209 10.0535 23.1321 9.71062 22.59C9.54694 22.3313 9.44082 22.0118 9.22859 21.3728Z",
    stroke: "#676767",
    strokeWidth: 1.875
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 23.75L18.5883 24.5583C18.4116 25.4421 18.3232 25.884 18.1252 26.2332C17.819 26.7732 17.3228 27.1799 16.7333 27.3743C16.352 27.5 15.9013 27.5 15 27.5C14.0987 27.5 13.648 27.5 13.2667 27.3743C12.6772 27.1799 12.181 26.7732 11.8748 26.2332C11.6768 25.884 11.5884 25.4421 11.4117 24.5583L11.25 23.75",
    stroke: "#676767",
    strokeWidth: 1.875
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6946 8.125L13.7925 10.2432C13.5311 10.5343 13.6902 10.9992 14.0751 11.0692L15.936 11.4076C16.3459 11.4821 16.4902 11.9957 16.1792 12.2728L13.8196 14.375",
    stroke: "#676767",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdInactive);
export default __webpack_public_path__ + "static/media/prodInactive.9ccd0ea23f928c1bae2cf36b4fa5fdae.svg";
export { ForwardRef as ReactComponent };